module.exports = __webpack_public_path__ + "img/checked.3e3c4e15.gif";